'use client'
import { Link } from '@/i18n/routing'
import { NavBar } from '@/modules/navigation/components/NavBar'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

const HomeHeader = () => {
  const t = useTranslations('home.hero')

  return (
    // Mobil liegt die fixierte Navi (top-8 plus rund 101px) ueber dem Hero.
    // Mit fester Hoehe h-[100dvh] und unten ausgerichtetem Inhalt rutschte die
    // H1 auf 320 bis 390px Breite darunter. Deshalb mobil min-h statt h und
    // 150px Abstand oben, ab lg bleibt es bei der bisherigen Hoehe.
    <header className="min-h-[100dvh] lg:h-[100dvh] lg:min-h-[min(1096px,120vh)] w-full [@media(max-width:1440px)]:px-8 lg:pt-16 pt-[150px] flex flex-col items-center bg-[url('/images/backgrounds/Flower-BG-02.jpg')] bg-cover bg-center ">
      <div className="w-full [@media(max-width:1440px)]:px-8 py-0 bg-transparent z-50 lg:fixed flex items-center justify-center">
        <NavBar />
      </div>
      <div className="lg:pb-[100px]" />
      {/* Keine framer-motion-Entrance mehr: das opacity:0 + blur(12px) auf diesem
          Wrapper verzögerte das Paint des LCP-Elements (Hero-h1) um ~3,4s (LCP 10,5s).
          Der Hero-Text rendert jetzt sofort. */}
      <article className="max-w-[1440px] w-full grow flex flex-col justify-end lg:justify-center pb-16 lg:pb-24 z-10 lg:pt-0">
        <h1 className=" inline-block  lg:block text-white  text-[clamp(2rem,9vw,3rem)] leading-[1.1] sm:leading-12 lg:text-[4rem] lg:leading-16 break-words sm:hyphens-auto lg:break-normal">
          {t('specialistsFor')} <br />
          <span className="font-medium text-accent">
            {t('brandDesign')} <br />& {t('webSolutions')}
          </span>
        </h1>

        <p className="text-white text-base lg:text-xl leading-6 lg:leading-7 mt-8 lg:mt-12 max-w-2xl font-light">{t('description')}</p>

        {/* data-hide-floating: mobil laege die Kontakt-Pille sonst ueber dem
            Hero-Button, solange die Buttons im Bild sind tritt sie zurueck. */}
        <div data-hide-floating className="flex flex-col sm:flex-row gap-4 lg:gap-6 mt-8 lg:mt-12">
          {/* Der Button verspricht eine KI-Analyse und fuehrte auf /kontakt.
              Die dafuer gebaute Seite existiert und war von der Startseite aus
              nicht verlinkt. */}
          <Link href="/kostenlose-ki-analyse" className="bg-accent hover:bg-accent/90 text-white px-8 py-4 rounded-3xl font-medium text-lg transition-all duration-200 hover:scale-105 text-center">
            {t('cta.discussProject')}
          </Link>
          <Link href="/projekte" className="bg-white hover:bg-white/90 text-KMRS-Darkmode px-8 py-4 rounded-3xl font-medium text-lg transition-all duration-200 hover:scale-105 text-center">
            {t('cta.ourProjects')}
          </Link>
        </div>
      </article>
      <Image
        src="/images/geometric-shapes/orange-line.svg"
        width={1920}
        height={2082}
        alt="decorative orange line"
        className="hidden lg:block absolute top-[254px] left-0 h-auto w-screen select-none"
      />
      <div className="absolute left-0 top-1/5 flex w-full h-[1639px] overflow-hidden">
        <Image
          src="/images/geometric-shapes/orange-line.svg"
          width={939}
          height={1689}
          alt="decorative orange line"
          className="block lg:hidden w-[939px] max-w-none select-none h-full object-cover absolute "
        />
      </div>
    </header>
  )
}
export default HomeHeader
